import { render, staticRenderFns } from "./apply-edits-modals.vue?vue&type=template&id=2cc0b4a7"
import script from "./apply-edits-modals.vue?vue&type=script&lang=js"
export * from "./apply-edits-modals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports